const CLIENT_AUTHORIZATION_INSUFFICIENT = 'CLIENT_AUTHORIZATION_INSUFFICIENT'
const CONFIGURATION = 'CONFIGURATION'
const HOSTED_FIELDS_FIELDS_INVALID = 'HOSTED_FIELDS_FIELDS_INVALID'
const US_BANK_ACCOUNT_NOT_ENABLED = 'US_BANK_ACCOUNT_NOT_ENABLED'

class BraintreeError extends Error {
  constructor (err) {
    const { code, details, message, name, type } = err
    super(message)
    this.name = name
    this.type = type
    this.details = details
    this.message = message
    this.code = code
    console.error('BraintreeError', this.code, this.message)
    // Parse the error
    this.parse()
  }

  parse () {
    switch (this.code) {
      case CLIENT_AUTHORIZATION_INSUFFICIENT:
        return this.authorizationError()
      case CONFIGURATION:
        return this.configurationError()
      case HOSTED_FIELDS_FIELDS_INVALID:
        return this.hostedFieldsError()
      case US_BANK_ACCOUNT_NOT_ENABLED:
        return this.configurationError()
      default:
        return this.unknownError()
    }
  }

  authorizationError () {
    this.message = 'Authorization error'
  }

  configurationError () {
    this.message = 'Configuration error'
  }

  hostedFieldsError () {
    this.message = 'Invalid card details'
  }

  unknownError () {
    this.message = 'Unknown error'
  }

  getMessage () {
    return this.message
  }
}

export default BraintreeError
